import { jsx } from 'react/jsx-runtime';
import styles from '../Footer.module.scss.js';
import Link from './Link.js';
import { LinkBehaviour } from '../../../types/shared.js';

const KeyLinks = ({ keyLinks }) => {
  return /* @__PURE__ */ jsx("div", { className: styles.keyLinksWrapper, "data-test-id": "footer-keylinks", children: /* @__PURE__ */ jsx("ul", { className: styles.keyLinks, children: keyLinks.map((link) => {
    const { behaviour, text = "", url } = link ?? {};
    const nextLink = behaviour === LinkBehaviour.Standard;
    const target = behaviour === LinkBehaviour.Standard ? "_self" : "_blank";
    const rel = behaviour === LinkBehaviour.Standard ? "_self" : "noopener noreferrer";
    return /* @__PURE__ */ jsx("li", { children: url ? /* @__PURE__ */ jsx(
      Link,
      {
        href: url,
        nextLink,
        target,
        testId: `footer-${text}`,
        rel,
        children: text
      }
    ) : /* @__PURE__ */ jsx("span", { "data-test-id": `footer-${text}`, children: text }) }, text);
  }) }) });
};

export { KeyLinks as default };
//# sourceMappingURL=KeyLinks.js.map
